"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _AccordionSectionModule = _interopRequireDefault(require("./AccordionSection.module.css"));
var ArrowIcon = function ArrowIcon(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "20",
    height: "20",
    className: _AccordionSectionModule["default"].icon,
    fill: color,
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
  }));
};
var LoadingIndicator = function LoadingIndicator(_ref2) {
  var color = _ref2.color;
  return /*#__PURE__*/_react["default"].createElement("center", null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      borderTop: "0.5em solid ".concat(color)
    },
    "data-testid": "AccordionSection-loader",
    className: _AccordionSectionModule["default"].Loader
  }));
};
var AccordionSection = function AccordionSection(props) {
  var autoScroll = props.autoScroll,
    isOpen = props.isOpen,
    onToggle = props.onToggle,
    loading = props.loading,
    sectionId = props.sectionId,
    title = props.title,
    secondaryColor = props.secondaryColor,
    primaryColor = props.primaryColor,
    loaderColor = props.loaderColor,
    className = props.className;
  var classNames = [_AccordionSectionModule["default"].Accordion, className];
  classNames[2] = isOpen ? '' : _AccordionSectionModule["default"].Closed;
  var accordion = (0, _react.useRef)();
  var scrollToSection = function scrollToSection() {
    var _accordion$current;
    window.scrollTo({
      top: ((_accordion$current = accordion.current) === null || _accordion$current === void 0 ? void 0 : _accordion$current.offsetTop) - 25,
      behavior: 'smooth'
    });
  };
  var handleClick = (0, _react.useCallback)(function () {
    onToggle();
    if (isOpen) return;
    if (!autoScroll) return;
    setTimeout(scrollToSection, 0);
  }, [onToggle, isOpen, autoScroll]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: accordion,
    "data-testid": "AccordionSection",
    id: sectionId
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "Accordion",
    onClick: handleClick,
    className: classNames.join(' '),
    style: {
      color: isOpen ? secondaryColor.color : primaryColor.color,
      backgroundColor: isOpen ? secondaryColor.backgroundColor : primaryColor.backgroundColor
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "Accordion-title"
  }, title), /*#__PURE__*/_react["default"].createElement(ArrowIcon, {
    color: isOpen ? secondaryColor.color : primaryColor.color
  })), isOpen && (loading ? /*#__PURE__*/_react["default"].createElement(LoadingIndicator, {
    color: loaderColor
  }) : props.children)));
};
AccordionSection.defaultProps = {
  className: '',
  loaderColor: 'black',
  title: undefined,
  onToggle: undefined,
  loading: false,
  isOpen: undefined,
  autoScroll: false,
  sectionId: '',
  primaryColor: {
    color: 'black',
    backgroundColor: 'white'
  },
  secondaryColor: {
    color: 'white',
    backgroundColor: 'black'
  }
};
var _default = AccordionSection;
exports["default"] = _default;